import requestDefault from '@/shared/utils/request';
import { ubtSendError } from '@/shared/utils/ubt';
import type {
  PopupIdEnum,
  PopupShowFatigueControl,
} from './types';

/** 已上报的弹窗曝光记录，用于防止重复上报（使用对象兼容低版本浏览器） */
const reportedExposureMap: Record<string, boolean> = {};

/**
 * 查询弹窗是否可展示
 * @param popupId 弹窗场景枚举
 * @returns 弹窗疲劳度查询结果
 */
export const queryPopupFatigue = (
  popupId: PopupIdEnum,
): Promise<PopupShowFatigueControl> => requestDefault.postGate(
  'f.popup.fatigue.query',
  {
    popupId,
  },
  {
    showLoading: undefined,
    showErrMsg: undefined,
  },
);

/**
 * 上报弹窗曝光(次数+1)
 * @param popupId 弹窗场景枚举
 * @param timeStamp 时间戳，使用 Date.now()
 * @returns Promise
 */
export const reportPopupExposure = (
  popupId: PopupIdEnum,
  timeStamp: number,
): Promise<void> => {
  // 生成唯一键：popupId + timeStamp
  const uniqueKey = `${popupId}_${timeStamp}`;

  // 检查是否重复上报
  if (reportedExposureMap[uniqueKey]) {
    // 重复上报，记录错误
    ubtSendError(
      `popup-exposure-duplicate-error: popupId=${popupId}, timeStamp=${timeStamp}`,
    );
  }

  // 记录已上报的组合
  reportedExposureMap[uniqueKey] = true;

  return requestDefault.postGate(
    'f.popup.callback',
    {
      popupId,
      timeStamp,
    },
    {
      showLoading: undefined,
      showErrMsg: undefined,
    },
  );
};

const PopupApi = {
  queryPopupFatigue,
  reportPopupExposure,
};

export default PopupApi;
